<template>
  <div id="ranking-porte-populacional-filters" class="ranking-filters">
    <div class="filters-left">
      <div class="filter-item">
        <label>Quadrimestre</label>
        <select
          :value="quadrimestre"
          @change="$emit('change-quadrimestre', $event.target.value)"
        >
          <option
            v-for="item in quadrimestres"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </option>
        </select>
      </div>

      <div class="filter-item">
        <label>Porte Populacional</label>
        <select
          :value="portePopulacional"
          :disabled="!quadrimestre"
          @change="$emit('change-porte-populacional', $event.target.value)"
        >
          <option value=""></option>
          <option
            v-for="item in optionsPortePopulacional"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </option>
        </select>
      </div>

      <div class="filter-item">
        <label>Região</label>
        <select
          :value="regiao"
          :disabled="!quadrimestre"
          @change="$emit('change-regiao', $event.target.value)"
        >
          <option value=""></option>
          <option value="Norte">N - Norte</option>
          <option value="Nordeste">NE - Nordeste</option>
          <option value="Centro-Oeste">CO - Centro-Oeste</option>
          <option value="Sudeste">SE - Sudeste</option>
          <option value="Sul">S - Sul</option>
        </select>
      </div>

      <div class="filter-actions">
        <button class="btn-clear" @click="$emit('limpar')">Limpar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RankingPortePopulacionalFilters',

  props: {
    quadrimestre: { type: String, default: '' },
    portePopulacional: { type: [String, Number], default: '' },
    quadrimestres: { type: Array, default: () => [] },
    optionsPortePopulacional: { type: Array, default: () => [] },
    regiao: { type: String, default: '' },
  },
}
</script>

<style scoped lang="scss">
#ranking-porte-populacional-filters {
  margin-bottom: 20px;

  .filters-left {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 16px;
    align-items: end;
    width: 100%;
  }

  .filter-item {
    display: flex;
    flex-direction: column;
    min-width: 0;

    label {
      font-size: 13px;
      font-weight: 700;
      color: #374151;
      margin-bottom: 6px;
    }

    select {
      width: 100%;
      height: 42px;
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      padding: 0 12px;
      outline: none;
      background: #ffffff;

      &:disabled {
        background: #f5f5f5;
        cursor: not-allowed;
      }
    }
  }

  .filter-actions {
    display: flex;
    align-items: flex-end;

    button {
      width: 100%;
      height: 42px;
      border: none;
      border-radius: 10px;
      font-weight: 700;
      cursor: pointer;
    }

    .btn-clear {
      background: #e5e7eb;
      color: #374151;

      &:hover {
        background: #d1d5db;
      }
    }
  }

  @media (max-width: 992px) {
    .filters-left {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 768px) {
    .filters-left {
      grid-template-columns: 1fr;
    }
  }
}
</style>
